export default __webpack_public_path__ + "static/media/invitation.285aa059.svg";